/*
  变量名统一用HTTP method结尾，如登录接口为get请求，则变量名为LOGIN_GET
*/
export const baseUrl = "";
//AUTH
export const LOGIN_GET = "/api/user/login";
export const TEST_URL_GET = "/api/test/url/get";

//USER
export const USER_REGISTER_POST = "/api/user/register";
export const USER_AGENT_INFO_EDIT_POST ="/api/user/agent/mod";
export const USER_SALE_INFO_EDIT_POST = "/api/user/sale/mod";

//Project
export const PROJECT_DELETE_POST = "/api/project/my/del";
export const PROJECT_ADD_POST = "/api/project/my/add";
export const PROJECT_MOD_POST = "/api/project/my/mod";
export const PROJECT_SET_PRODUCTION_POST = "/api/project/product/set";
export const PROJECT_PRODUCTION_LIST_GET = "/api/project/product/get";
export const PROJECT_PRODUCT_UPDATE_POST = "/api/project/product/mod";
export const PROJECT_PRODUCT_DELETE_POST = "/api/project/product/delete";

//System
export const PRODUCT_MODEL_ADD_POST = "/api/product/category/add";
export const PRODUCT_MODEL_MOD_POST = "/api/product/category/update";
export const PRODUCT_MODEL_DELETE_POST = "/api/product/category/delete";
export const PROPERTY_MOD_POST = "/api/system/setting/mod";